import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import Spinner from 'src/Components/Spinner';
import { TEST_ID_PROP_NAME } from '@wolffun/testable-id';

const Button = ({
  className,
  title,
  onClick,
  disabled,
  loading,
  [TEST_ID_PROP_NAME]: dataTestId
}) => /*#__PURE__*/React.createElement("button", {
  [TEST_ID_PROP_NAME]: dataTestId,
  disabled: disabled || loading,
  onClick: onClick,
  className: classNames(styles.container, className)
}, !loading ? /*#__PURE__*/React.createElement("span", {
  className: styles.title
}, title) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
  className: styles.loading,
  secondary: true,
  size: 24
}), /*#__PURE__*/React.createElement("span", {
  className: styles.title
}, title)));

export default Button;